import * as React from 'react';

import { st, classes } from './SocialBarIcon.st.css';
import { Tooltip } from '../Tooltip';
import { useTPAComponentsContext } from '../TPAComponentsConfig';
import { IconButton, IconButtonSkins } from '../IconButton';
import { SocialBarIconProps } from './types';
import { useSocialBarContext } from './SocialBarContext';
import { SocialBarIconTestHook } from './consts';

export const SocialBarIcon = ({
  children,
  tooltip,
  socialBarTheme,
  className,
  hasLiveRegion,
  'data-hook': dataHook,
  ...rest
}: SocialBarIconProps) => {
  const { mobile } = useTPAComponentsContext();
  const theme = useSocialBarContext();

  const Wrapper = theme ? 'li' : 'div';

  const liveRegion = hasLiveRegion
    ? ({ role: 'status', 'aria-live': 'polite' } as const)
    : {};

  return (
    <Wrapper
      className={st(
        classes.root,
        { theme: theme || socialBarTheme, mobile },
        className,
      )}
    >
      <div {...liveRegion}>
        <Tooltip
          appendTo="scrollParent"
          content={tooltip}
          placement="top"
          disabled={!tooltip || mobile}
        >
          <IconButton
            className={classes.iconButton}
            skin={IconButtonSkins.Full}
            as="a"
            type={null}
            data-hook={dataHook ?? SocialBarIconTestHook}
            {...rest}
          />
        </Tooltip>
      </div>
    </Wrapper>
  );
};
